import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Storage() {
  const [storageList, setStorageList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем по категории STORAGE
        const storageItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'storage'
        );

        setStorageList(storageItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="storage">
      <h1>Накопители</h1>
      <div className="storage__list">
        {storageList.length > 0 ? (
          storageList.map((st) => (
            <div key={st.id} className="storage__card">
              <img src={st.image} alt={st.name} />
              <h2>{st.name}</h2>
              <p className="specs">{st.description}</p>
              <p className="price">{st.price}</p>
              <Link to={`/components/storage/${st.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
